export const JWT = 'GD_jwt'
export const CREDS = 'GD_creds'
export const DESTINATION_PATH = 'GD_destinationPath'
export const IS_LOGGED_IN = 'GD_isLoggedIn'
export const GD_USER_MNEMONIC = 'GD_mnemonic'
export const GD_USER_MASTERSEED = 'GD_masterSeed'
export const GD_USER_PRIVATEKEYS = 'GD_privateKeys'
export const GD_INITIAL_REG_METHOD = 'GD_initialRegMethod'
export const IS_FIRST_VISIT = 'GD_isFirstVisit'
export const AB_TESTING = 'GD_abTesting'
export const INVITE_CODE = 'GD_inviteCode'
export const BROWSER_CHECKED = 'GD_browserChecked'
